import type { TranslationTemplate } from "src/datahandling/localization/application.i18n";

export default {
	DataType: {
		Appetite: "Appetitt",
		Biomass: "Biomasse",
		Dose: "Dose",
		FeedAmount: "Fôrmengde",
		FishWeight: "Fiskevekt",
		HandFeedWeight: "Håndfôringsvekt",
		Intensity: "Intensitet",
		Loadcell: "Lastcelle",
		ManualAmount: "Manuell mengde",
		Mean: "Gjennomsnitt",
		PelletCount: "Pelletantall",
		PelletFishMinute: "Pellet per fisk per minutt",
		Planned: "Planlagt",
		Recommended: "Anbefalt",
		SFR: "SFR",
		SGR: "SGR",
		StandardAppetite: "Standard appetitt",
		Target: "Mål",
		TodayAppetite: "Dagens appetitt",
		TotalFeedWeight: "Total fôrvekt",
		avgWeight: "Gjennomsnittlig vekt",
		blowerSpeed: "Blåserhastighet",
		compass: "Kompass",
		conductivity: "Ledningsevne",
		fcr: "FCR",
		feedStoreAmount: "Fôrlager mengde",
		humidity: "Luftfuktighet",
		latitude: "Breddegrad",
		longitude: "Lengdegrad",
		pellet_count: "Pelletantall",
		pressure: "Trykk",
		pressurePipe: "Rørtrykk",
		recommendedFeedWeight: "Anbefalt fôrvekt",
		runtime: "Driftstid",
		sal_conductivity: "Salinitet ledningsevne",
		sal_density: "Salinitet tetthet",
		sal_sound_speed: "Salinitet lydhastighet",
		sal_temp: "Salinitet temperatur",
		saturation: "Metning",
		sc_abs_tilt: "Havstrøm absolutt tilt",
		sc_heading: "Havstrøm retning",
		sc_max_tilt: "Havstrøm maks tilt",
		sc_sp_standard: "Havstrøm hastighet standard",
		sc_std_tilt: "Havstrøm standard tilt",
		sc_strength: "Havstrøm styrke",
		sc_tilt_x: "Havstrøm tilt X",
		sc_tilt_y: "Havstrøm tilt Y",
		sea_current_absolute_speed: "Havstrøm hastighet",
		sea_current_direction: "Havstrøm retning",
		sea_current_east: "Havstrøm øst",
		sea_current_north: "Havstrøm nord",
		sensor_depth: "Sensordybde",
		sgr: "SGR",
		smartSpreaderCycleTime: "Smart spreder syklustid",
		smartSpreaderCyclicMax: "Smart spreder syklisk maks",
		smartSpreaderCyclicMin: "Smart spreder syklisk min",
		smartSpreaderManualSpeed: "Smart spreder manuell hastighet",
		targetRecommended: "Mål anbefalt",
		temperatureFeedingLine: "Temperatur fôrlinje",
		water_oxygen_mg_l: "Oksygen (mg/L)",
		water_oxygen_percentage: "Oksygen (%)",
		water_oxygen_umol: "Oksygen (μmol)",
		water_salinity: "Salinitet",
		water_temperature: "Temperatur",
		wind_direction: "Vindretning",
		wind_speed: "Vindhastighet",
	},
	DataTypeDescription: {
		AppetiteDescription: "Appetittnivå hos fisk i prosent",
		BiomassDescription: "Total estimert biomassevekt",
		DoseDescription: "Fôrdose per fôringshendelse",
		FeedAmountDescription: "Total mengde fôr utdelt",
		FishWeightDescription: "Estimert individuell fiskevekt",
		HandFeedWeightDescription: "Vekt av fôr utdelt for hånd",
		IntensityDescription: "Fôringsintensitet",
		LoadcellDescription: "Lastcelle vektmåling",
		ManualAmountDescription: "Manuelt registrert fôrmengde",
		MeanDescription: "Gjennomsnittlig fôrvekt",
		PelletCountDescription: "Antall pellets utdelt",
		PelletFishMinuteDescription: "Pellets per fisk per minutt",
		PlannedDescription: "Planlagt fôrmengde",
		RecommendedDescription: "Anbefalt fôrmengde",
		SFRDescription: "Spesifikk fôringsrate",
		SGRDescription: "Spesifikk vekstrate",
		StandardAppetiteDescription: "Standardisert appetittnivå",
		TargetDescription: "Målfôrmengde",
		TodayAppetiteDescription: "Appetittnivå for i dag",
		TotalFeedWeightDescription: "Total vekt av utdelt fôr",
		avgWeightDescription: "Gjennomsnittlig fiskevekt",
		blowerSpeedDescription: "Fôrblåser hastighet",
		compassDescription: "Kompassretning",
		conductivityDescription: "Elektrisk ledningsevne i vannet",
		fcrDescription: "Fôrfaktor",
		feedStoreAmountDescription: "Mengde fôr i lageret",
		humidityDescription: "Luftfuktighetsnivå",
		latitudeDescription: "GPS breddegradskoordinat",
		longitudeDescription: "GPS lengdegradskoordinat",
		pellet_countDescription: "Pelletantall fra sensor",
		pressureDescription: "Atmosfærisk eller vanntrykk",
		pressurePipeDescription: "Trykk i fôrrør",
		recommendedFeedWeightDescription: "Anbefalt fôrvektmengde",
		runtimeDescription: "Utstyr driftstid",
		sal_conductivityDescription: "Ledningsevne fra salinitetssensor",
		sal_densityDescription: "Vanntetthet fra salinitetssensor",
		sal_sound_speedDescription: "Lydhastighet fra salinitetssensor",
		sal_tempDescription: "Temperatur fra salinitetssensor",
		saturationDescription: "Oksygenmetningsnivå",
		sc_abs_tiltDescription: "Absolutt tilt på havstrømsensor",
		sc_headingDescription: "Retning på havstrømsensor",
		sc_max_tiltDescription: "Maks tilt på havstrømsensor",
		sc_sp_standardDescription: "Standardhastighet fra havstrømsensor",
		sc_std_tiltDescription: "Standardavvik for tilt",
		sc_strengthDescription: "Havstrøm signalstyrke",
		sc_tilt_xDescription: "Havstrømsensor tilt på X-aksen",
		sc_tilt_yDescription: "Havstrømsensor tilt på Y-aksen",
		sea_current_absolute_speedDescription: "Absolutt hastighet på havstrøm",
		sea_current_directionDescription: "Retning på havstrøm",
		sea_current_eastDescription: "Østlig komponent av havstrøm",
		sea_current_northDescription: "Nordlig komponent av havstrøm",
		sensor_depthDescription: "Dybde på sensoren",
		sgrDescription: "Spesifikk vekstrate",
		smartSpreaderCycleTimeDescription: "Syklustid for smart spreder",
		smartSpreaderCyclicMaxDescription: "Maksimal syklisk hastighet for smart spreder",
		smartSpreaderCyclicMinDescription: "Minimal syklisk hastighet for smart spreder",
		smartSpreaderManualSpeedDescription: "Manuell hastighetsinnstilling for smart spreder",
		targetRecommendedDescription: "Mål anbefalt fôrmengde",
		temperatureFeedingLineDescription: "Temperatur i fôrlinjen",
		water_oxygen_mg_lDescription: "Oppløst oksygen i mg per liter",
		water_oxygen_percentageDescription: "Oppløst oksygen i prosent",
		water_oxygen_umolDescription: "Oppløst oksygen i mikromol",
		water_salinityDescription: "Salinitetsnivå i vannet",
		water_temperatureDescription: "Vanntemperatur",
		wind_directionDescription: "Vindretning",
		wind_speedDescription: "Vindhastighet",
	},
} satisfies TranslationTemplate["DATA_TYPES"];
